import React, { useContext, useState } from 'react';
import { FaXTwitter } from 'react-icons/fa6';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';

import { BsCheckSquare } from 'react-icons/bs';
import { FaFacebook, FaLink, FaLinkedin } from 'react-icons/fa';
import { SITE_DOMAIN } from '../../constants';
import { LocationContext } from '../../contexts/LocationContext';
import { pushClickShareButtonEvent, withDataLayer } from '../../tracking/dataLayer';
import { clsx, urlJoin } from '../../utils/utils';
import * as styles from './SocialMediaShare.module.scss';

interface SocialMediaShareProps {
  className?: string;
}

const SocialMediaShare = ({ className }: SocialMediaShareProps): React.ReactElement => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const location = useContext(LocationContext);

  const currentUrl = location?.pathname ? SITE_DOMAIN + urlJoin(location.pathname) : '';

  async function copyUrlToClipboard() {
    await navigator.clipboard.writeText(currentUrl);
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  }

  return (
    <div className={clsx(styles.socialMediashareContainer, className)} data-theme={'light'}>
      <div className={styles.firstRow}>
        <LinkedinShareButton
          url={currentUrl}
          className={styles.linkContainer}
          onClick={() => {
            withDataLayer(pushClickShareButtonEvent({ type: 'linkedin' }));
          }}
        >
          <FaLinkedin className={styles.icon} />
          <span className={styles.visuallyHidden}>LinkedIn</span>
        </LinkedinShareButton>
        <FacebookShareButton
          url={currentUrl}
          className={styles.linkContainer}
          onClick={() => {
            withDataLayer(pushClickShareButtonEvent({ type: 'facebook' }));
          }}
        >
          <FaFacebook className={styles.icon} />
          <span className={styles.visuallyHidden}>Facebook</span>
        </FacebookShareButton>
        <TwitterShareButton
          url={currentUrl}
          className={styles.linkContainer}
          onClick={() => {
            withDataLayer(pushClickShareButtonEvent({ type: 'instagram' }));
          }}
        >
          <FaXTwitter className={styles.icon} />
          <span className={styles.visuallyHidden}>Twitter</span>
        </TwitterShareButton>
      </div>
      <div className={styles.divider}></div>
      <button
        className={clsx(styles.linkContainer, styles.copyToClipboard)}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={copyUrlToClipboard}
      >
        <FaLink className={styles.icon} />
        <span className={clsx(styles.sucessMessage, !showSuccessMessage && styles.hidden)}>
          <BsCheckSquare /> Copied to clipboard
        </span>
        <span className={styles.visuallyHidden}>Copy to clipboard</span>
      </button>
    </div>
  );
};

export default SocialMediaShare;
